
// SEO configurations for product pages
export const productSEOConfig = {
  auto: {
    title: "Auto Insurance in Fayetteville GA | Cheap Car Insurance Quotes",
    description: "Get affordable car insurance in Fayetteville, GA. Compare rates from multiple carriers for the best cheap auto insurance coverage.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, cheap car insurance Fayetteville GA, affordable auto insurance Georgia, car insurance quotes"
  },
  home: {
    title: "Home Insurance in Fayetteville GA | Affordable Homeowners Coverage",
    description: "Protect your home with affordable homeowners insurance in Fayetteville, GA. Multiple carriers for the best coverage and rates.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, homeowners insurance Fayetteville GA, house insurance Georgia"
  },
  commercial: {
    title: "Commercial Insurance in Georgia | Business Coverage Solutions",
    description: "Commercial insurance solutions for Georgia businesses. General liability, workers comp, property coverage and more.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, business insurance Georgia, commercial insurance Fayetteville GA, workers comp Georgia"
  },
  bonds: {
    title: "Surety Bonds in Georgia | Title, Court & Contract Bonds",
    description: "Fast title bonds, court bonds, probate bonds and contract bonds in Georgia. Easy online bond application and same-day service.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, title bond Georgia, surety bonds Fayetteville GA, court bonds, probate bonds, contract bonds"
  }
};
